/* The edit bar under the chart: where a save goes. Into the active collection when it is the
   user's own; otherwise — the base is read-only — into the collection chosen here, which
   becomes the active one at the first save. It also carries the one line about charts an
   older build left on this device, which is shown whether or not edit mode is on. */

import { el, fill } from "../../ui/dom";
import { dom } from "./layout";
import { NEW_COPY, activeIsOwn, chooseTarget, currentTarget, saveTargets } from "./save";
import { page } from "./state";

function waitingLine(n: number): HTMLElement {
  return el(
    "span",
    { class: "waiting", dataset: { testid: "waiting-edits" } },
    `${n} chart${n > 1 ? "s" : ""} you edited on this device ${n > 1 ? "are" : "is"} waiting to be moved into a collection. `,
    el("a", { href: "./collections.html#device" }, "Move them"),
  );
}

export function renderEditsPanel(): void {
  const p = page();
  const host = dom.store;
  fill(host);
  host.hidden = !p.editMode && !p.waiting; // reading needs no write tools
  if (host.hidden) return;

  if (p.editMode) {
    const { collection } = p.session;
    if (activeIsOwn()) {
      host.append(
        el(
          "span",
          { dataset: { testid: "save-target" } },
          // As text, like every name a user wrote. The base is everyone's: an administrator
          // is told so in words that cannot be taken for the usual.
          collection.isBase
            ? `You are an administrator: changes are saved into "${collection.name}", for everyone.`
            : `Changes are saved into "${collection.name}" and follow you to every device.`,
        ),
      );
    } else {
      // A native select, like the switcher: the user's collections, then a new copy.
      const target = el(
        "select",
        {
          class: "copy",
          ariaLabel: "The collection a save goes into",
          dataset: { testid: "save-target" },
          onchange: () => chooseTarget(target.value),
        },
        saveTargets().map((c) => el("option", { value: c.id }, c.name)),
        el("option", { value: NEW_COPY }, `A new copy of ${collection.name}`),
      );
      target.value = currentTarget();
      host.append(
        el(
          "span",
          {},
          `"${collection.name}" is read-only. A save writes the chart into `,
          target,
          ", which then becomes the active collection.",
        ),
      );
    }
  }

  if (!p.waiting) return;
  if (p.editMode) host.append(el("span", { class: "spacer" }));
  host.append(waitingLine(p.waiting));
}
